import script from "./CopyToClipboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyToClipboard.vue?vue&type=script&setup=true&lang=ts"

import "./CopyToClipboard.vue?vue&type=style&index=0&id=c64f5376&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c64f5376"]])

export default __exports__